module.exports = __webpack_public_path__ + "assets/img/info.4dcfb474.png";